import React, { useRef, useState, useEffect } from "react";
import { Globe, Check, ChevronDown } from "lucide-react";
import { useLang } from "@/i18n/LangContext";
import { LANG_OPTIONS } from "@/i18n/translations";

export const LanguageSwitcher = ({ variant = "desktop" }) => {
  const { lang, setLang } = useLang();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const current = LANG_OPTIONS.find((l) => l.code === lang) || LANG_OPTIONS[0];
  const sfx = variant === "desktop" ? "" : `-${variant}`;

  useEffect(() => {
    const onDoc = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, []);

  return (
    <div className="relative" ref={ref}>
      <button
        data-testid={`lang-switcher-button${sfx}`}
        onClick={() => setOpen((o) => !o)}
        className="flex items-center gap-1.5 rounded-lg border border-slate-200 bg-white px-2.5 py-2 text-sm font-semibold text-slate-600 transition-colors hover:bg-slate-100"
        aria-label="Cambia lingua"
      >
        <Globe className="h-4 w-4 text-emerald-600" />
        <span>{current.flag}</span>
        <span className="hidden text-xs uppercase sm:inline">{current.code}</span>
        <ChevronDown className={`h-3.5 w-3.5 text-slate-400 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>

      {open && (
        <div
          data-testid={`lang-menu${sfx}`}
          className="absolute right-0 z-50 mt-2 w-44 overflow-hidden rounded-xl border border-slate-200 bg-white py-1 shadow-lg"
        >
          {LANG_OPTIONS.map((opt) => (
            <button
              key={opt.code}
              data-testid={`lang-option-${opt.code}${sfx}`}
              onClick={() => {
                setLang(opt.code);
                setOpen(false);
              }}
              className={`flex w-full items-center gap-2.5 px-3 py-2.5 text-left text-sm transition-colors hover:bg-slate-50 ${
                opt.code === lang ? "bg-emerald-50" : ""
              }`}
            >
              <span className="text-base">{opt.flag}</span>
              <span className={`flex-1 ${opt.code === lang ? "font-bold text-emerald-700" : "text-slate-700"}`}>
                {opt.label}
              </span>
              {opt.code === lang && <Check className="h-4 w-4 text-emerald-600" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
